import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleTransform',
  standalone: true,
})
export class TitleTransformPipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (typeof value === 'string') {
      // Replace underscores with spaces, then capitalize the first letter of each word
      return value
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .replace(/\s+/g, ' ')
        .trim();
    }
    return value;
  }
}
